@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-raised" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{ "mailmessages.periodicDetail.saveButton" | transloco }}</span>
        </button>
        @if (id > 0) {
            <button class="btn btn-raised red" (click)="deleteClick()">
                <i class="fas fa-trash"></i>
                <span>{{ "mailmessages.periodicDetail.deleteButton" | transloco }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card" [formGroup]="form">
        <div class="detail-page-card-title">
            {{ "mailmessages.periodicDetail.editPeriodicTitle" | transloco }}
        </div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'mailmessages.periodicDetail.nameLabel' | transloco"
                    formControlName="name"
                    name="notification-name"
                    dataUiid="periodic-detail-moi-name"
                    [required]="true"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    [label]="'mailmessages.periodicDetail.activeLabel' | transloco"
                    data-uiid="periodic-detail-moi-active"
                    formControlName="active"
                ></cerrix-checkbox>
            </div>
            <div class="form-group">
                <label>{{ "mailmessages.periodicDetail.periodLabel" | transloco }}</label>
                <ng-select
                    id="periodSelect"
                    name="periodSelect"
                    [items]="periods"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="period"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                    (change)="setDayNumbers($event)"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.dayLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.dayTooltip' | transloco"
                        matTooltipClass="breakable-tooltip"
                    ></i>
                </label>
                <ng-select
                    id="dayNumberSelect"
                    name="dayNumberSelect"
                    [items]="dayNumbers"
                    [readonly]="!notification.period"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="dayNumber"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                ></ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "mailmessages.periodicDetail.organizationLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.organizationTooltip' | transloco"
                    ></i>
                </label>
                <cerrix-select-tree
                    class="fullWidth"
                    [getDataMethod]="organizationRequest"
                    formControlName="organizations"
                    [multiselect]="true"
                ></cerrix-select-tree>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.moiTypeLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.moiTypeTooltip' | transloco"
                    ></i>
                </label>
                <ng-select
                    id="moiTypeSelect"
                    name="moiTypeSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="moiTypes"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="moiTypeIds"
                    [placeholder]="'mailmessages.periodicDetail.allPlaceholder' | transloco"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "mailmessages.periodicDetail.userTypeLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.userTypeTooltip' | transloco"
                    ></i>
                </label>
                <ng-select
                    id="userTypeSelect"
                    name="userTypeSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="userTypes"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="userTypeIds"
                    [placeholder]="'mailmessages.periodicDetail.allPlaceholder' | transloco"
                >
                </ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "mailmessages.periodicDetail.priorityLabel" | transloco }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'mailmessages.periodicDetail.priorityTooltip' | transloco"
                    ></i>
                </label>
                <ng-select
                    id="prioritySelect"
                    name="prioritySelect"
                    [items]="priorities"
                    bindLabel="Name"
                    [closeOnSelect]="false"
                    bindValue="ID"
                    [multiple]="true"
                    formControlName="priorityIds"
                    [placeholder]="'mailmessages.periodicDetail.anyPlaceholder' | transloco"
                ></ng-select>
            </div>

            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'mailmessages.periodicDetail.messageLabel' | transloco"
                    formControlName="subject"
                    name="notification-subject"
                    dataUiid="periodic-detail-moi-subject"
                    [required]="true"
                    [placeholder]="'mailmessages.periodicDetail.requiredPlaceholder' | transloco"
                    (click)="setFocusToSubject()"
                ></cerrix-textfield>
                @for (keyword of keywords; track keyword) {
                    <button class="keyword-button" (click)="addKeyword(keyword)">
                        {{ keyword }}
                    </button>
                }
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="notification.message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChange($event)"
                    (click)="deFocusSubject()"
                    #editor
                ></cerrix-editor>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
